import React from 'react'
import ReactDOM from 'react-dom'
import { createStore } from 'redux'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import * as Sentry from '@sentry/browser'
import Application from './Application'
import reducers from './reducers'
import * as serviceWorker from './serviceWorker'
import './index.scss'


Sentry.init({dsn: "https://7656ea73bb5541908d56037970eb92f3@o372876.ingest.sentry.io/5262204"})

const store = createStore(reducers)

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter className='application'>
        <Application />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
